module.exports = __webpack_public_path__ + "04_short_black.da4e0076.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_short_black.png
// module id = lg9F
// module chunks = 0